import { render, staticRenderFns } from "./AscUserCommentStatus.vue?vue&type=template&id=031bdc64&"
import script from "./AscUserCommentStatus.vue?vue&type=script&lang=js&"
export * from "./AscUserCommentStatus.vue?vue&type=script&lang=js&"
import style0 from "./AscUserCommentStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports